import ResultCard from './ResultCard'
import { displayValue, formatChatDate } from './chatFormatters'
import { GuaranteeDetail } from './types'

interface Props {
  detail: GuaranteeDetail
  titleId?: string
}

/** Garanti sorgusu sonucu. Modalda ve sohbet balonunda aynı kart gösterilir. */
export default function GuaranteeCard({ detail, titleId }: Props) {
  return (
    <ResultCard
      titleId={titleId}
      eyebrow={`Seri no ${detail.serialNumber}`}
      title={displayValue(detail.productName)}
      subtitle={displayValue(detail.productCode)}
      badge={displayValue(detail.warrantyStatus)}
      items={[
        { label: 'Garanti durumu', value: displayValue(detail.warrantyStatus) },
        { label: 'Marka', value: displayValue(detail.brand) },
        { label: 'Fatura no', value: displayValue(detail.invoiceNumber) },
        { label: 'Okutma tarihi', value: formatChatDate(detail.readingDate) },
        { label: 'Kategori kodu', value: displayValue(detail.categoryCode) },
      ]}
    />
  )
}
